//
//
//
//
//
//
//
//
//
//
//
//

import wxConfig from '@/assets/js/wx_config'

export default {
    name: "videoResource",
    data(){
        return{
            resourceId:this.$route.query.r,
            videoFlag:false,
            style:{},
            playerOptions : {
                playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: 'zh-CN',
                aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [{
                type: "video/mp4",//这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
                src: "" //url地址
                }],
                poster: "", //你的封面地址
                // width: document.documentElement.clientWidth, //播放器宽度
                notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                timeDivider: true,
                durationDisplay: true,
                remainingTimeDisplay: false,
                fullscreenToggle: true  //全屏按钮
                }
            }
        }
    },
    created(){
        this.getVideo()
    },
    mounted() {
        this.$store.commit('UPDATE_HEAD',false);
        this.$store.commit('UPDATE_FOOTER',false);
        this.$store.commit('UPDATE_PAGE_TITLE','视频播放');
        document.title = '视频播放'
        
        let divHeight = document.getElementById("videoDiv").clientHeight;
        let bodyHeight = document.documentElement.clientHeight
        this.style = {
            "marginTop":(bodyHeight - divHeight) / 5 * 1.5 + 'px'
        }

    },
    methods:{
        getVideo(){
            let self = this;
            this.baseAjax({
                url:'/h5/resource/get',
                showLoading:true,
                type:'post',
                data:{
                    "resourceId":this.resourceId
                },
                success:function (data) {
                    if(data.resultCode === 0){
                        self.initVideo(data.resource)
                        if(wxConfig.isWeiXin()){
                            let title = data.resource.user.nickName + "分享了一段视频"
                            let desc = data.resource.user.nickName + "分享了一段视频"
                            let linkUrl = "http://dev.mobile.mianhuain.com/#/video?r=" + this.resourceId
                            let imgUrl = data.resource.thumbnailUrl100;
                            wxConfig.wxConfigBuild_in(title,desc,linkUrl,imgUrl);
                        }
                    }
                }
            })
        },
        initVideo(resource){
            let videoPoster = resource.thumbnailHDUrl;
            this.playerOptions.poster = videoPoster
            this.playerOptions.sources[0].src = resource.url
            this.videoFlag = true
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/resource/videoResource.vue